export enum PayoutMethod {
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  MOBILE_WALLET = 'MOBILE_WALLET',
  PROVIDER_WALLET = 'PROVIDER_WALLET',
  CASH = 'CASH',
}
